import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Form section
      form: {
        title: 'Birth Data',
        fullName: 'Full Name',
        email: 'E-mail',
        birthDate: 'Birth Date',
        birthTime: 'Birth Time',
        city: 'City',
        cityPlaceholder: 'Search for a city',
        submit: 'Generate Chart',
        generateMap: 'Generate Astral Map',
        fillMockData: 'Fill with Mock Data'
      },
      // Error messages
      errors: {
        required: 'This field is required',
        invalidDate: 'Invalid date',
        invalidTime: 'Invalid time',
        invalidCity: 'Please select a valid city',
        futureDate: 'Birth date cannot be in the future',
        invalidEmail: 'Please enter a valid email address'
      },
      // Chart section
      chart: {
        title: 'Astral Chart',
        personalInfo: 'Personal Information',
        name: 'Name',
        birthDate: 'Birth Date',
        birthTime: 'Birth Time',
        city: 'City',
        location: 'Location',
        planetaryPositions: 'Planetary Positions',
        houses: 'Houses',
        house: 'House',
        ascendant: 'Ascendant',
        loading: 'Calculating positions...',
        downloadPDF: 'Download PDF',
        generateNewMap: 'Generate New Map',
        generateTikkunMap: 'Generate Tikkun Map',
        // Planetary positions
        sun: 'Sun',
        moon: 'Moon',
        mercury: 'Mercury',
        venus: 'Venus',
        mars: 'Mars',
        jupiter: 'Jupiter',
        saturn: 'Saturn',
        uranus: 'Uranus',
        neptune: 'Neptune',
        pluto: 'Pluto',
        lilith: 'Lilith',
        northNode: 'Tikkun',
        chiron: 'Chiron',
        sirius: 'Sirius'
      },
      // Zodiac signs
      signs: {
        aries: 'Aries',
        taurus: 'Taurus',
        gemini: 'Gemini',
        cancer: 'Cancer',
        leo: 'Leo',
        virgo: 'Virgo',
        libra: 'Libra',
        scorpio: 'Scorpio',
        sagittarius: 'Sagittarius',
        capricorn: 'Capricorn',
        aquarius: 'Aquarius',
        pisces: 'Pisces'
      },
      houses: {
        First: 'First',
        Second: 'Second',
        Third: 'Third',
        Fourth: 'Fourth',
        Fifth: 'Fifth',
        Sixth: 'Sixth',
        Seventh: 'Seventh',
        Eighth: 'Eighth',
        Ninth: 'Ninth',
        Tenth: 'Tenth',
        Eleventh: 'Eleventh',
        Twelfth: 'Twelfth'
      },
      tikkun: {
        title: 'Tikkun Chart',
        description: 'Calculate your Tikkun chart based on your birth data',
        comingSoon: 'Coming Soon - This feature will be available in the next update'
      }
    }
  },
  pt: {
    translation: {
      Lilith: 'Lua Negra',
      "North Node": 'Tikkun',
      // Form section
      form: {
        title: 'Dados de Nascimento',
        fullName: 'Nome Completo',
        email: 'E-mail',
        birthDate: 'Data de Nascimento',
        birthTime: 'Hora de Nascimento',
        city: 'Cidade',
        cityPlaceholder: 'Pesquisar por uma cidade',
        submit: 'Gerar Mapa',
        generateMap: 'Gerar Mapa Astral',
        fillMockData: 'Preencher com Dados de Exemplo'
      },
      // Error messages
      errors: {
        required: 'Este campo é obrigatório',
        invalidDate: 'Data inválida',
        invalidTime: 'Hora inválida',
        invalidCity: 'Por favor, selecione uma cidade válida',
        futureDate: 'A data de nascimento não pode ser futura',
        invalidEmail: 'Por favor, insira um endereço de e-mail válido'
      },
      // Chart section
      chart: {
        title: 'Mapa Astral',
        personalInfo: 'Informações Pessoais',
        name: 'Nome',
        birthDate: 'Nascimento',
        birthTime: 'Hora de Nascimento',
        city: 'Cidade',
        location: 'Localização',
        planetaryPositions: 'Posições Planetárias',
        houses: 'Casas',
        house: 'Casa',
        ascendant: 'Ascendente',
        loading: 'Calculando posições...',
        downloadPDF: 'Baixar PDF',
        generateNewMap: 'Gerar Novo Mapa',
        generateTikkunMap: 'Gerar Mapa Tikkun',
        // Planetary positions
        sun: 'Sol',
        moon: 'Lua',
        mercury: 'Mercúrio',
        venus: 'Vênus',
        mars: 'Marte',
        jupiter: 'Júpiter',
        saturn: 'Saturno',
        uranus: 'Urano',
        neptune: 'Netuno',
        pluto: 'Plutão',
        lilith: 'Lua Negra',
        northNode: 'Tikkun',
        chiron: 'Chiron',
        sirius: 'Sirius',
      },
      // Zodiac signs
      signs: {
        aries: 'Áries',
        taurus: 'Touro',
        gemini: 'Gêmeos',
        cancer: 'Câncer',
        leo: 'Leão',
        virgo: 'Virgem',
        libra: 'Libra',
        scorpio: 'Escorpião',
        sagittarius: 'Sagitário',
        capricorn: 'Capricórnio',
        aquarius: 'Aquário',
        pisces: 'Peixes'
      },
      houses: {
        First: 'Primeira Casa',
        Second: 'Segunda Casa',
        Third: 'Terceira Casa',
        Fourth: 'Quarta Casa',
        Fifth: 'Quinta Casa',
        Sixth: 'Sexta Casa',
        Seventh: 'Sétima Casa',
        Eighth: 'Oitava Casa',
        Ninth: 'Nona Casa',
        Tenth: 'Décima Casa',
        Eleventh: 'Décima Primeira Casa',
        Twelfth: 'Décima Segunda Casa'
      },
      tikkun: {
        title: 'Mapa Tikkun',
        description: 'Calcule seu mapa Tikkun com base nos seus dados de nascimento',
        comingSoon: 'Em Breve - Este recurso estará disponível na próxima atualização'
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt', // Default to Portuguese
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 